var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{ref:"chart",style:({ width: _vm.width, height: _vm.height })})])
}
var staticRenderFns = []

export { render, staticRenderFns }